import { AUCTION_TYPES } from 'constants';

export const useGetAdditionalBidText = (auctionType, startingBid = 100) => {
  const defaultValue = { color: '', text: '' };
  return bid => {
    if (auctionType === AUCTION_TYPES.AUTOAXESS) return defaultValue;
    if (startingBid > bid.bid) {
      return { color: '#3994DE', text: 'Below minimum' };
    }
    return defaultValue;
  };
};
